export enum PERMISSOES {
  CONCLUIR_VISTORIA = '24995bb5-6e30-perm-8f7b-b342cda0299b',
}
